import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
    CLEAR_EDITOR_COMMAND,
    COMMAND_PRIORITY_LOW,
    KEY_ENTER_COMMAND
} from "lexical";
import {useEffect} from "react";

export default function OnSubmit({onSubmit = ()=>{}, autoClear = false, active = true}) {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        return editor.registerCommand(
            KEY_ENTER_COMMAND,
            (event) => {
                if (!event.shiftKey && active && !document.querySelector('.mentions-menu')) {
                    event.preventDefault();
                    onSubmit(editor.getEditorState());
                    return autoClear ? editor.dispatchCommand(CLEAR_EDITOR_COMMAND) : true;
                }
                else return false;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor, onSubmit, autoClear, active]);
    return null;
}
